import classNames from 'classnames';
import { Button, FlexContainer, Txt } from 'components';
import { useProperty, useDataActions } from 'state';
import { useState } from 'react';
import styles from './TodoItemAlarms.module.scss';

/**
 * TodoItemAlarms
 *
 * @return {JSX.Element}
 */
const TodoItemAlarms = ({ className, onSuccess }) => {
  const propertyDoc = useProperty();
  const storageActions = useDataActions();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    await storageActions.property.updateSmokeAlarms(propertyDoc);
    setIsLoading(false);
    return onSuccess && onSuccess();
  };

  return (
    <FlexContainer
      className={classNames(
        styles.TodoItemEPC,
        className,
        TodoItemAlarms.displayName
      )}
      column
      gap
    >
      <Txt>🔁 Checked per tenancy</Txt>
      <Txt regular>
        Smoke and carbon monoxide alarms should be in good working order.
        Tenants should also be advised to check they are functioning regularly.
      </Txt>
      <Button success onClick={handleSubmit} disabled={isLoading}>
        Mark as done
      </Button>
    </FlexContainer>
  );
};

TodoItemAlarms.displayName = 'TodoItemAlarms';

export default TodoItemAlarms;
